import React from 'react';

import { LiveblogTenant } from '../../typings/liveblog-themes';
import { ComponentProps } from '../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../utils/styles';
import './pagination.scss';
import t from '../../labels/labelling-utils';
import IconArrowLink from '../icons/icon-arrow-link';

export interface IPagination extends ComponentProps {
  prevLink?: string;
  nextLink?: string;
  tenant: LiveblogTenant;
}

const classNames = (): IClassNames =>
  makeClassNames({
    Pagination: 'pagination',
    PgButton: 'pagination__button',
    PgButtonPrev: 'pagination__button--prev',
    PgButtonNext: 'pagination__button--next',
    PgButtonIcon: 'pagination__button-icon',
    PgButtonLabel: 'pagination__button-text',
  });

const intcmpPrefix = {
  tg24: 'skytg24',
  sport: 'skysports_livedata',
};

const Pagination: React.FC<IPagination> = ({ prevLink, nextLink, tenant }) => {
  const prevPageNumber = parseInt(prevLink?.split('lbp')[1]?.split('=')[1] || '', 10);
  const nextPageNumber = parseInt(nextLink?.split('lbp')[1]?.split('=')[1] || '', 10);
  const cn = classNames();

  return (
    <div className={cn.Pagination}>
      {prevLink && (
        <a
          className={`${cn.PgButton} ${cn.PgButtonPrev}`}
          href={prevLink}
          data-intcmp={`${intcmpPrefix[tenant]}_liveblog_prev-page_${prevPageNumber}`}
        >
          <span className={cn.PgButtonIcon}>
            <IconArrowLink width={18} reverseX />
          </span>
          <span className={cn.PgButtonLabel}>{t('pagination.button.label.prev')}</span>
        </a>
      )}

      {nextLink && (
        <a
          className={`${cn.PgButton} ${cn.PgButtonNext}`}
          href={nextLink}
          data-intcmp={`${intcmpPrefix[tenant]}_liveblog_next-page_${nextPageNumber}`}
        >
          <span className={cn.PgButtonLabel}>{t('pagination.button.label.next')}</span>
          <span className={cn.PgButtonIcon}>
            <IconArrowLink width={18} />
          </span>
        </a>
      )}
    </div>
  );
};

export default Pagination;
